import events from '../blocks/index/events';
import goods from '../blocks/index/goods';

if (document.body.classList.contains('index-page')) {
    events();
    goods()
}
